import { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, { PaginationProvider }  from "react-bootstrap-table2-paginator";
import { getAuthorities } from "../../../../../../_helpers/Helpers";
import * as actions from "../../../_redux/teacher-courses/TeacherCoursesAction";
import * as uiHelpers from "../TeacherCoursesUIHelpers";
import { 
  getSelectRow, 
  getHandlerTableChange,  
  NoRecordsFoundMessage, 
  PleaseWaitMessage, 
  sortCaret
} from "../../../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { Pagination } from "../../../../../../_metronic/_partials/controls";
import { useTeacherCoursesUIContext } from "../TeacherCoursesUIContext";

export function TeacherCoursesTable({ 
  deleteTeacherCourses 
}) {
  // Teacher Courses UI Context
  const teacherCoursesUIContext = useTeacherCoursesUIContext();
  const teacherCoursesUIProps = useMemo(() => {
    return {
      ids: teacherCoursesUIContext.ids,
      setIds: teacherCoursesUIContext.setIds,
      queryParams: teacherCoursesUIContext.queryParams,
      setQueryParams: teacherCoursesUIContext.setQueryParams
    };
  }, [teacherCoursesUIContext]);

  // Getting curret state of Teacher Courses list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.teacherCourses }),
    shallowEqual
  );
  const { totalCount, entities, authorities, listLoading } = currentState;
  
  // Authority Parameters
  const { isDeletionAuthorized } = getAuthorities(authorities);
  
  // Teacher Courses Redux state
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.getTeacherCourses(teacherCoursesUIProps.queryParams));
    return () => dispatch(actions.cleanTeacherCoursesState())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [teacherCoursesUIProps.queryParams, dispatch]);

  // Table columns
  const columns = [
    {
      dataField: "gradeLevelName",
      text: "Sınıf Düzeyi",
      sort: true,
      sortCaret: sortCaret,
    },
    {
      dataField: "section",
      text: "Sınıf",
      sort: true,
      sortCaret: sortCaret
    },
    {
      dataField: "teacher",
      text: "Öğretmen",
      sort: true,
      sortCaret: sortCaret,
    },
    {
      dataField: "branch",
      text: "Branş",
      sort: true,
      sortCaret: sortCaret
    },
    {
      dataField: "course",
      text: "Ders",
      sort: true,
      sortCaret: sortCaret
    },
  ];

  const actionColumn = {
    dataField: "action",
    text: "İşlemler",
    formatter: columnFormatters.ActionsColumnFormatter,
    formatExtraData: {
      isDeletionAuthorized,
      deleteTeacherCourses
    },
    classes: "text-right pr-7",
    headerClasses: "text-right pr-3",
    style: {
      width: "100px",
    }
  }

  if (isDeletionAuthorized) columns.push(actionColumn);

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: teacherCoursesUIProps.queryParams.pageSize,
    page: teacherCoursesUIProps.queryParams.pageNumber
  };
  
  return (
    <PaginationProvider pagination={paginationFactory(paginationOptions)}>
      {({ paginationProps, paginationTableProps }) => {
        return (
          <Pagination
            isLoading={listLoading}
            paginationProps={paginationProps}
          >
            <BootstrapTable
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden"
              bootstrap4
              bordered={false}
              remote
              keyField="id"
              data={entities ? entities : [] }
              columns={columns}
              defaultSorted={uiHelpers.defaultSorted}
              onTableChange={getHandlerTableChange(
                teacherCoursesUIProps.setQueryParams
              )}
              selectRow={getSelectRow({
                entities,
                ids: teacherCoursesUIProps.ids,
                setIds: teacherCoursesUIProps.setIds,
                hidden: !isDeletionAuthorized
              })}
              {...paginationTableProps}
            >
              <PleaseWaitMessage entities={entities} />
              <NoRecordsFoundMessage entities={entities} />
            </BootstrapTable>
          </Pagination>
        );    
      }}
    </PaginationProvider>  
  );
}